<template>
  <main>
    <!-- {{ parentInfo }} -->
    <v-container>
      <v-toolbar flat class="main-header mb-12">
        <v-toolbar-title class="main-header__title">
          <h1>Parents</h1>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-items class="main-header__contents">
          <v-btn
            class="button btn-height--1 my-auto mx-1"
            color="primary"
            :to="`/accounts/parents/create?account=${$route.query.account}`"
            rounded
          >
            <span class="mx-2">Add Parent</span>
          </v-btn>
          <v-btn
            class="button btn-height--1 my-auto mx-1"
            color="success"
            :to="`/accounts/children/create?account=${$route.query.account}`"
            rounded
          >
            <span class="mx-2">Add Child</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="parentInfo"
        :mobile-breakpoint="zero"
        :items-per-page="20"
        class="table"
        hide-default-footer
      >
        <template v-slot:item="{ item, index }">
          <tr class="table__row">
            <td class="table__cell text-center name">{{ item.name }}</td>
            <td class="table__cell text-center">{{ item.email }}</td>
            <td class="table__cell text-center">{{ item.mobile }}</td>
            <td class="table__cell text-center">
              {{ item.relation ? item.relation.name : "---" }}
            </td>
            <td class="table__cell text-center">
              <i v-if="item.primary === 1" class="gold-icon icon-active"></i>
              <i v-else class="icon-inactive icon-inactive"></i>
            </td>
            <td class="table__cell text-center">
              <v-chip
                v-if="!item.has_complete_profile"
                small
                color="#faddd2"
                text-color="#ec531e"
              >
                <v-icon small>mdi-close-circle</v-icon>
              </v-chip>
              <v-chip v-else small color="#dcf3d1" text-color="#82c565">
                <v-icon small>mdi-checkbox-marked-circle</v-icon>
              </v-chip>
            </td>
            <td class="table__cell text-center">
              <router-link
                class="hovering mr-1 edit"
                :to="`/accounts/parents/create/${item.id}`"
              >
                <v-icon small>mdi-pencil</v-icon><br />
                Edit
              </router-link>
              <span
                v-if="item.primary === 0"
                @click="handleDeleteParent(item, index)"
                class="hovering delete"
              >
                <v-icon small>mdi-delete</v-icon><br />
                Delete
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>
      <!-- {{ children }} -->
      <!-- pagination -->
      <div class="text-xs-center pt-2">
        <v-pagination
          v-if="parentInfo.length > 0 && pagination.last_page > 1"
          v-model="pagination.current_page"
          :length="pagination.last_page"
          :total-visible="20"
          @input="handlePagination"
        ></v-pagination>
      </div>
      <!-- pagination -->
      <!-- Account {{ " #" + $route.query.search + " " }} -->
      <v-toolbar flat class="main-header mb-12">
        <v-toolbar-title class="main-header__title">
          <h1>Children</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-data-table
        :headers="childrenTable"
        :items="children"
        :mobile-breakpoint="zero"
        :items-per-page="20"
        class="table"
        hide-default-footer
      >
        <template v-slot:item="{ item, index }">
          <tr class="table__row">
            <td class="table__cell text-center">
              <v-avatar size="50">
                <v-img
                  v-if="item.photo_url != null"
                  :src="item ? item.photo_url : '--'"
                ></v-img>
                <span v-else>No Photo</span>
              </v-avatar>
            </td>
            <td class="table__cell text-center">{{ item.wellspring_id }}</td>
            <td class="table__cell text-center name">{{ item.full_name }}</td>
            <!-- <td class="table__cell text-center name">
              {{ item.card_invoice_no || "---" }}
            </td> -->

            <td class="table__cell text-center">
              <i
                v-if="item.is_reg_fees_paid == '1'"
                class="icon-active blue-coloring"
              ></i>
              <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
            </td>
            <td class="table__cell text-center">
              <i
                v-if="item.card_issued == '1'"
                class="icon-active blue-coloring"
              ></i>
              <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
            </td>
            <td class="table__cell text-center">
              <i
                v-if="item.is_insured == '1'"
                class="icon-active blue-coloring"
              ></i>
              <v-icon v-else>mdi-checkbox-blank-circle-outline</v-icon>
            </td>
            <td class="table__cell text-center">
              <v-chip
                v-if="!item.has_complete_profile"
                small
                color="#faddd2"
                text-color="#ec531e"
              >
                <v-icon small>mdi-close-circle</v-icon>
              </v-chip>
              <v-chip v-else small color="#dcf3d1" text-color="#82c565">
                <v-icon small>mdi-checkbox-marked-circle</v-icon>
              </v-chip>
            </td>
            <td class="table__cell text-center">
              <router-link
                class="hovering mr-1 edit"
                :to="`/accounts/children/create/${item.id}`"
              >
                <v-icon small>mdi-pencil</v-icon><br />
                Edit
              </router-link>
              <span class="hovering delete" @click="handleDelete(item, index)">
                <v-icon small>mdi-delete</v-icon><br />
                Delete
              </span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-container>
  </main>
</template>

<script>
import { ShowData, DeleteData } from "@/helpers/apiMethods";
import TableHeaders from "@/helpers/TableHeaders";
import { isEqual } from "lodash";

export default {
  data() {
    return {
      parentInfo: [],
      children: [],
      childrenTable: [],
      zero: 0,
      headers: [],
      pagination: {},
      queries: {}
    };
  },
  created() {
    this.parentsData();
    // this.childrenData();
    this.parentsHeaders();
    this.childrenHeaders();
    console.log(this.$route.query, "this.$route.query");
  },
  methods: {
    parentsData() {
      ShowData({
        reqName: `accounts`,
        id: this.$route.query.account
      })
        .then(res => {
          console.log(res);

          const { account } = res.data;
          this.parentInfo = account.parents;
          this.children = account.children;
        })
        .catch(() => {});
    },
    parentsHeaders() {
      const headersList = [
        "Name",
        "Email",
        "Mobile",
        "Relation",
        "Primary",
        "Completed",
        "Actions"
      ];
      this.headers = TableHeaders(headersList);
    },
    childrenHeaders() {
      const headersList = [
        "Photo",
        "Wellspring ID",
        "Name",
        // "Invoice No",
        "Paid",
        "Issued",
        "Insured",
        "Completed",
        "Actions"
      ];
      this.childrenTable = TableHeaders(headersList);
    },
    handlePagination(page) {
      this.queries = { ...this.queries, page };
      if (!isEqual(this.queries, this.$route.query)) {
        this.$router.push({ query: this.queries });
      }
    },
    handleDelete({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/children`,
            id: id
          })
            .then(() => {
              this.children.splice(index, 1);
            })
            .catch(() => {});
        }
      });
    },
    handleDeleteParent({ id }, index) {
      this.popUp().then(value => {
        if (!value.dismiss) {
          DeleteData({
            reqName: `/parents`,
            id: id
          })
            .then(() => {
              this.parentInfo.splice(index, 1);
              // this.$delete(this.parentInfo, index);
            })
            .catch(() => {});
        }
      });
    }
  }
};
</script>
